import { requireAuth } from '../wrappers/requireAuth'
import { PlaidConnectedAccountsSection } from '../components/plaidConnectedAccountsSection'

function ConnectedAccounts() {
  // Reachable by everyone. Users whose plan lacks the Plaid feature see the
  // section with a disabled "Connect a new account" button + "contact us to
  // enable sync" tooltip (see PlaidConnectedAccountsSection) rather than being
  // redirected away.
  return <div className='row'>
    <div className='col-12'>
      <h1 className='text-center'>Connected Accounts</h1>
      <div className='mt-4'>
        <PlaidConnectedAccountsSection />
      </div>
    </div>
  </div>
}

export default requireAuth(ConnectedAccounts)
